import { inject, Injectable } from '@angular/core';
import { ConstructionProjectLoadModel } from '@construction/models/construction-project.model';
import { UserSignalStore } from '@core/stores/user-signal-store.service';

export type ProjectRoleKey =
  | 'EPCQualityManagerRemediate'
  | 'EPCQualityManagerCreateRemediate'
  | 'OwnerConstructionManager'
  | 'OwnerCompanyUser'
  | 'EPCCompanyUser'
  | 'SupplierCompanyUser'
  | 'AccountOwnerCompanyUser';

function isInList(list: Array<{ _id: string }> | undefined, id: string): boolean {
  return list?.some((member) => member._id === id) ?? false;
}

@Injectable({
  providedIn: 'root',
})
export class ConstructionProjectRoleService {
  private readonly userStore = inject(UserSignalStore);

  public hasRole(project: ConstructionProjectLoadModel, role: ProjectRoleKey): boolean {
    const user = this.userStore.user();
    if (!user) return false;
    const contactProfileId = user.contact_profile._id;
    const companyProfileId = user.company_profile?._id;
    if (role === 'EPCQualityManagerRemediate') return isInList(project.epc_quality_managers, contactProfileId);
    if (role === 'EPCQualityManagerCreateRemediate') return isInList(project.epc_cr_quality_managers, contactProfileId);
    if (role === 'OwnerConstructionManager') return isInList(project.owner_construction_managers, contactProfileId);
    if (role === 'OwnerCompanyUser') return !!user.company_profile && companyProfileId === project.owner_company;
    if (role === 'EPCCompanyUser') return !!user.company_profile && companyProfileId === project.epc_company;
    if (role === 'SupplierCompanyUser') return !!user.company_profile && companyProfileId === project.supplier_company;
    if (role === 'AccountOwnerCompanyUser') return companyProfileId === project.project.account_owner_company?._id;

    return false;
  }
}
